interface FenceNode {
  name: string;
  from: number;
  to: number;
  firstChild: FenceNode | null;
  nextSibling: FenceNode | null;
}

export interface MermaidFence {
  from: number;
  to: number;
  codeFrom: number;
  code: string;
}

export function parseMermaidFence(node: FenceNode, source: string): MermaidFence | null {
  if (node.name !== "FencedCode") return null;
  let info: FenceNode | null = null;
  let body: FenceNode | null = null;
  for (let child = node.firstChild; child; child = child.nextSibling) {
    if (child.name === "CodeInfo") info = child;
    else if (child.name === "CodeText") body = child;
  }
  if (!info || !body || !/^mermaid(?:\s|$)/i.test(source.slice(info.from, info.to).trim()))
    return null;
  const code = source.slice(body.from, body.to).trim();
  return code ? { from: node.from, to: node.to, codeFrom: body.from, code } : null;
}
